import { useState, Fragment, useEffect } from 'react';
import ReactTooltip from "react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";


export function TooltipInfo({ showTooltip, creditUser }) {

    const [dataToolTip, setDataTooltip] = useState([]);

    const handleDatatoolTip = () => {
        const optionscurrency = { style: 'currency', currency: 'COP' };
        const numberFormat = new Intl.NumberFormat('es-CO', optionscurrency);
        const admon = 60000;
        //Calcular IVA
        const iva = Math.round(admon * (19 / 100));
        //Calcular interes
        const interest = Math.round(
            parseInt(creditUser?.approvedQuota) * (0.0626666 / 100) * creditUser?.termInDays
        );

        const parseNumber = (number) => {
            let _numberFormat = numberFormat.format(number);
            let _numberString = _numberFormat.split(',')[0];
            if (_numberString.length === 0) {
                _numberString = '$0'
            }
            return _numberString;
        }

        let _data =
            [
                { title: "Monto Solicitado: ", value: `${parseNumber(parseInt(creditUser?.approvedQuota))} \n` },
                { title: "Interes corriente(25%E.A): ", value: `${parseNumber(interest)} \n` },
                { title: "Administración (opcional): ", value: `${parseNumber(admon)} \n` },
                { title: "IVA: ", value: `${parseNumber(iva)} \n` }
            ];
        setDataTooltip(_data);
        return;
    }

    useEffect(() => {
        handleDatatoolTip();
    }, [creditUser]);


    return (

        <Fragment>

            <InformationCircleIcon
                data-tip
                data-for="int"
                className="w-4 h-auto ml-0.5 font-bold cursor-pointer"
                onMouseLeave={handleDatatoolTip}
            />
            {showTooltip && (
                <ReactTooltip
                    place="top"
                    id="int"
                    type="dark"
                    effect="solid"
                    className="w-72"
                >
                    {
                        dataToolTip.map((item, index) => {
                            return <h2 key={index}>{`${item?.title} \n ${item?.value}`}</h2>
                        })
                    }

                </ReactTooltip>
            )}

        </Fragment>


    )
}


export function TooltipInfoV2({ showTooltip, approvedQuota, interest, dctoFirmaElectronica, firmaElectronica, discountForReward, checkFirmaElectronica }) {
    const [dataToolTip, setDataTooltip] = useState([]);

    useEffect(() => {
        handleDatatoolTip();
    }, [discountForReward]);

    const handleDatatoolTip = () => {
        const optionscurrency = { style: 'currency', currency: 'COP' };
        const numberFormat = new Intl.NumberFormat('es-CO', optionscurrency);

        const parseNumber = (number) => {
            let _numberFormat = numberFormat.format(number);
            let _numberString = _numberFormat.split(',')[0];
            if (_numberString.length === 0) {
                _numberString = '$0'
            }
            return _numberString;
        }

        let _data =
            [
                { title: "Monto Solicitado: ", value: `${parseNumber(approvedQuota)} \n` },
                { title: "Interes corriente(25%E.A): ", value: `${parseNumber(interest)} \n` },
                { title: "Firma electrónica (opcional): ", value: `${parseNumber(firmaElectronica)} \n` },
                { title: "Descuento firma electrónica: ", value: `${dctoFirmaElectronica === 0 ? "" : "-"}${parseNumber(dctoFirmaElectronica)} \n` },
            ];
        if (discountForReward > 0) {
            if (checkFirmaElectronica) {
                _data.push({ title: "Descuento recompensa: ", value: `${parseNumber(-discountForReward)} \n` });
            }
        }
        setDataTooltip(_data);
        return;
    }

    useEffect(() => {
        handleDatatoolTip();
    }, [interest, dctoFirmaElectronica]);

    return (

        <Fragment>

            <InformationCircleIcon
                data-tip
                data-for="int"
                className="w-4 h-auto ml-0.5 font-bold cursor-pointer"
                onMouseLeave={handleDatatoolTip}
            />
            {showTooltip && (
                <ReactTooltip
                    place="top"
                    id="int"
                    type="dark"
                    effect="solid"
                    className="w-72"
                >
                    {
                        dataToolTip.map((item, index) => {
                            return <h2 key={index}>{`${item?.title} \n ${item?.value}`}</h2>
                        })
                    }

                </ReactTooltip>
            )}

        </Fragment>


    )
}